<template>
    <div class="input-control composite-box">
        <div class="primary-control">
            <component :is="primaryControl" v-bind="primaryControlProps" :initial-value="initialPrimaryValue"
                       ref="primaryControl" @valueChanged="reValidateValue" @keydownEnter="onLeftControlKeydownEnter"></component>
        </div>
        <div class="unit-control">
            <component :is="unitControl" v-bind="unitControlProps" :initial-value="initialUnitValue" ref="unitControl"
                       @valueChanged="reValidateValue"></component>
        </div>
    </div>
</template>

<script>
    import InputControlBase from "@/InputControls/InputControlBase";

    export default {
        name: "CompositeBoxForNumber",
        mixins: [InputControlBase],
        props: {
            primaryControl: Object,
            primaryControlProps: Object,
            unitControl: Object,
            unitControlProps: Object,
            unitProperty: String,
            fixedUnitValue: String
        },
        created() {
            this.value = this.value || null;
        },
        methods: {
            onLeftControlKeydownEnter() {
                this.$refs.unitControl.focus();
            },
            setUnitControlValue(v) {
                if (!this.fixedUnitValue) {
                    this.$refs.unitControl.setInputValue(v);
                }
            },
            setInputValue(value) {
                if (value) {
                    const amount = value.amount;
                    const unit = value[this.unitProperty];
                    this.$refs.primaryControl.setInputValue(amount);
                    this.setUnitControlValue(unit);
                } else {
                    this.$refs.primaryControl.setInputValue(null);
                    this.setUnitControlValue(null);
                }
            },
            focus() {
                this.$refs.primaryControl.focus();
            },
            reValidateValue() {
                const amount = this.$refs.primaryControl.getValue();
                const unit = this.$refs.unitControl.getValue();
                if (amount === null && (unit === null || this.fixedUnitValue)) {
                    this.value = null;
                } else {
                    const v = {amount: amount};
                    v[this.unitProperty] = unit;
                    this.value = v;
                }
            }
        },
        data() {
            return {
                initialPrimaryValue: this.initialValue && this.initialValue.amount,
                initialUnitValue: (this.initialValue && this.initialValue[this.unitProperty]) || this.fixedUnitValue
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "input-controls";

    .input-control.composite-box {
        display: flex;
        align-items: center;

        .primary-control {
            flex: 1 1 auto;
            min-width: 0;
            padding-right: 0.25rem;

            .input-control {
                width: 100%;
            }
        }
    }
</style>
